import Vue from 'vue'
import * as types from './mutation-types'

export default {
  [types.SET_BUCKET_ITEMS] (state, { bucket, items }) {
    Vue.set(state, bucket, items)
  },
  [types.SET_ITEM] (state, { isNew = true, itemObj }) {
    const stateItems = state[itemObj.itemBucket || 'cart']
    if (!(itemObj.id in stateItems)) {
      Vue.set(stateItems, itemObj.id, {})
    }
    if (isNew) {
      state.newItem = itemObj
    }
    Vue.set(stateItems[itemObj.id], itemObj.instanceId, itemObj)
  },
  [types.SET_QUESTION] (state, { itemBucket = 'cart', itemId, itemInstanceId, questionId, value }) {
    Vue.set(state[itemBucket][itemId][itemInstanceId].values, questionId, { value })
  },
  [types.SET_SPECIAL_REQUESTS] (state, { itemBucket = 'cart', itemId, itemInstanceId, value }) {
    Vue.set(state[itemBucket][itemId][itemInstanceId], 'specialRequests', value)
  },
  [types.REMOVE_ITEM] (state, { itemBucket = 'cart', id, instanceId }) {
    Vue.delete(state[itemBucket][id], instanceId)
    if (Object.keys(state[itemBucket][id]).length === 0) {
      Vue.delete(state[itemBucket], id)
    }
  },
  [types.RESET_BUCKET] (state, { itemBucket }) {
    Vue.set(state, itemBucket, {})
  },
  [types.RESET_ALL_BUCKETS] (state) {
    Vue.set(state, 'cart', {})
    Vue.set(state, 'favorites', {})
  }
}
